/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Spark = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="spark" />;

export { Spark, Spark as default };
